import { Button } from '@usitsdasdesign/dds-react'
import Text from 'atoms/Text'
import Image from 'next/image'
import PropTypes from "prop-types"

function Empty({ children, icon, message, description, onClick, ctaLabel, height, className, isShowCta = true, width = 'max-w-[224px]', isButtonDisabled=false } = {}) {
    return (
        <div className={`flex items-center justify-center ${className} ${height}`}>
            <div className={`${width} mx-auto text-center flex flex-col gap-3 items-center`}>
                <Image
                    src={icon}
                    width={85}
                    height={95}
                    objectFit='contain'
                    alt='404 Not found'
                />
                <Text variant='bodySemibold'>{message}</Text>
                {description && <Text variant='label' className='text-gray-1100'>{description}</Text>}
                {
                    isShowCta && (
                        <Button
                            isDisabled={isButtonDisabled}
                            label={ctaLabel}
                            size='l'
                            onClick={onClick}
                        />
                    )
                }
                {children}
            </div>
        </div>
    )
};

Empty.defaultProps = {
    icon: '/assets/icons/empty.svg',
    message: 'No data found',
    description: '',
    onClick: () => false,
    ctaLabel: 'New Demand',
    height: 'h-full',
    className: ''
};

Empty.propTypes = {
    icon: PropTypes.string,
    message: PropTypes.string,
    description: PropTypes.string,
    onClick: PropTypes.func,
    ctaLabel: PropTypes.string,
    height: PropTypes.string,
    className: PropTypes.string
};

export default Empty